<!--20211102 sea bert-->
<template>
  <div >
    <div class="special-tabs">
      <div
          class="tabs-item"
          :class="activeName === item.name ? 'tabs-item-active' : ''"
          v-for="(item, index) in tabList"
          :key="index"
          @click="onTabClick(index,item)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SpecialTabs",
  props: {
    tabList: {
      type: Array,
      default: []
    },
    activeName: {
      type: String,
      default: ''
    },
  },
  data() {
    return {};
  },
  computed: {
    // tabListNew() {
    //   return {
    //     "--length": this.tabList.length
    //   };
    // }
  },
  methods: {
    onTabClick(index, item) {
      // 需要修改
      // if (item.class != "") {
      //   return;
      // }
      // this.tabList.some((item) => {
      //   if (item.class != '') {
      //     item.class = ''
      //   }
      // })
      // this.tabList[index].class = 'tabs-item-active'
      this.$emit('onClick', item);
    }
  },
};
</script>
<style lang="scss" scoped>
.special-box {
  position: relative;
  top: -59px;
  text-align: center;
  z-index: 10;
}
.special-tabs {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
  display: inline-block;
  font-size: 0;
  border-radius: 10px;
  background: #fff;
  //width: 800px;

  .tabs-item {
    //margin:0 15px;
    height: 97px;
    line-height: 97px;
    min-width: 205px;
    padding: 0 10px;
    border-radius: 10px;
    background: #ffffff;
    font-size: 20px;
    font-weight: 500;
    color: #000000;
    text-align: center;
    display: inline-block;

    &:hover {
      min-width: 205px;
      background: linear-gradient(180deg, #6badf2 0%, #3b8de3 100%);
      position: relative;
      cursor: pointer;
      border-radius: 10px;
      color: #fff;

      &:after {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #3b8de3;
        position: absolute;
        left: 50%;
        bottom: -10px;
        transform: translateX(-50%);
      }
    }
  }

  .tabs-item-active {
    //width: 205px;
    background: linear-gradient(180deg, #6badf2 0%, #3b8de3 100%);
    position: relative;
    border-radius: 10px;
    color: #fff;

    &:after {
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid #3b8de3;
      position: absolute;
      left: 50%;
      bottom: -10px;
      transform: translateX(-50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// SpecialTabs.vue?402a885a